'use client';

import { useContext } from 'react';
import { OffersModalNewContext } from 'components/shared/OffersModal';
import { ImageModal } from 'components/ring-air/ProductSelectionSection/ImageModal';
import { CampaignForm } from './zero-campaign/CampaignForm';
import { useBloodVision } from '../BloodVisionContext';

/**
 * Hook to show the Blood Vision Free Campaign modal
 * Call showCampaignModal() to display the modal
 * Automatically pre-fills pincode from context
 */
export const useBvFreeCampaignModal = () => {
  const modal = useContext(OffersModalNewContext);
  const { zipCode, selectedPlan } = useBloodVision();

  const showCampaignModal = () => {
    if (modal) {
      modal.set(
        <ImageModal>
          <CampaignForm
            title="Almost there"
            description="Share your email address to activate your free Blood Vision test."
            preSelectedCountry="US"
            disableCountrySelect={true}
            isModal={true}
            preFilledPincode={zipCode}
            preSelectedPlanId={selectedPlan?.plan_id}
            ctaText="Book now"
            ctaSuccessText="Purchase succesful"
            sourceURL="pricing"
          />
        </ImageModal>,
      );
      modal.show();
    }
  };

  return { showCampaignModal };
};
